// extracted by mini-css-extract-plugin
export default {"cancelModal__hint":"OMwyykUn","cancelModal__error":"SRU_Sgz3"};